module.exports = {
  "country": "AZ",
  "artist": "Aysel & Arash",
  "song": "Always",
  "year": "2009",
  "place": "3",
  "spotify": "4xMRFkFYufAuTEKR0YMN3Z"
};